import { render, staticRenderFns } from "./wealthDetail.vue?vue&type=template&id=924bf1d6&scoped=true&"
import script from "./wealthDetail.vue?vue&type=script&lang=js&"
export * from "./wealthDetail.vue?vue&type=script&lang=js&"
import style0 from "./wealthDetail.vue?vue&type=style&index=0&id=924bf1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924bf1d6",
  null
  
)

export default component.exports